import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_ACTION_MANAGE_CONVERSIONS } from 'scenes/Integrations/constants';
import {
  FILTER_TYPES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  FILTER_PARTNERS,
  FILTER_APPLICATIONS,
  FILTER_ACTIVITY_TYPES,
} from 'scenes/Integrations/constants';

import * as Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_TYPES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  FILTER_PARTNERS,
  FILTER_APPLICATIONS,
  FILTER_ACTIVITY_TYPES,
];

const PrimaryFilters = () => {
  const isAllowedManageConversions = useIsAllowed()(
    PERMISSION_ACTION_MANAGE_CONVERSIONS
  );

  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <Filters.Types withClear={true} />
      <Filters.BusinessPartners withClear={true} />
      <Filters.Affiliates dropdownWidth={'440px'} withClear={true} />
      <Filters.Applications withClear={true} />
      <Filters.Events withClear={true} />
      {isAllowedManageConversions ? (
        <Filters.Partners withClear={true} />
      ) : null}
      <Filters.ActivityType withClear={true} />
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
